import React, { useState, useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import sparkles from '../../assets/icons8-sparkle-24.png';

const SpeechToText = ({ onTextChange, generate, isLoading }) => {
  const { transcript, resetTranscript, listening, finalTranscript } = useSpeechRecognition();
  const [text, setText] = useState('');
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    if (!isRecording) {
      setText(transcript);
      localStorage.setItem('transcribedText', transcript);
    }
  }, [isRecording, transcript]);

  const handleStartRecognition = () => {
    resetTranscript(); // Reset transcript when starting a new recording
    SpeechRecognition.startListening({ continuous: true });
    setIsRecording(true);
  };
  
  const handleStopRecognition = () => {
    SpeechRecognition.stopListening();
    setIsRecording(false);
  };
  
  const handleTextChange = (event) => {
    const newText = event.target.value;
    setText(newText);
    localStorage.setItem('transcribedText', newText);
  };

  const handleTryAgain = () => {
    resetTranscript(); // Reset transcript when trying again
    setText('');
  };

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return <span>Browser does not support speech recognition.</span>;
  }

  return (
    <div className="flex flex-col items-center">
      {text ? (
        <textarea 
          className="w-full h-48 p-4 mb-4 text-lg text-black border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-custom-orange focus:border-transparent" 
          value={text} 
          placeholder="Once you end your recording, your text will appear here."
          disabled={isRecording}
          onChange={handleTextChange}
        />
      ) : (
        <div className="flex items-center justify-center w-full h-48 p-4 mb-4 text-xl text-black rounded-md focus:outline-none focus:ring focus:ring-custom-orange focus:border-transparent">
          <p className="text-center">When you're ready, start recording and tell us about <span className='text-2xl font-bold'>what you sell</span>, the <span className='text-2xl font-bold'>problem it solves</span>, and who the <span className='text-2xl font-bold'>buyer</span> is.</p>
        </div>
      )}
      <div className="flex space-x-4 mb-3 sm:mb-0">
      {isRecording ? (
        <button
          onClick={handleStopRecognition}
          disabled={isLoading}
          className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          I'm finished
        </button>
      ) : text ? (
        <button
          onClick={handleTryAgain}
          disabled={isLoading}
          className="mb-3 rounded-full bg-white px-4 py-2.5 text-md font-semibold text-custom-orange border-2 border-custom-orange shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          Try Again
        </button>
      ) : (
        <button
          onClick={handleStartRecognition}
          disabled={listening}
          className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          Start recording
        </button>
      )}
      {!isRecording && text && (
        <button
          type="button"
          className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          onClick={generate}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="flex items-center">
              <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Generating...
            </span>
          ) : (
            <>
              <img src={sparkles} alt="sparkles" className="w-5 inline-block transform -translate-y-0.5" />&nbsp;&nbsp;Generate
            </>
          )}
        </button>
      )}
      </div>
    </div>
  );
};

export default SpeechToText;
